const WEBCHAT_REGIONS = ["EU", "AU"];

// Narrows VUE_APP_REGION, the region this build serves, to the values the live-webchat
// embed contract names. Mirrors live-webchat/src/contracts/embed.ts `asWebchatRegion`
// (and axa-web-app/up-spa); keep them in step. Null for an absent or unrecognised value,
// with no default: the wrong region files the conversation in the wrong Flex account, so
// an env file that forgets the variable gets no live chat.
export const webchatRegion = value =>
  WEBCHAT_REGIONS.find(region => region === value) ?? null;

export default {
  //TODO use process.env.VUE_APP_API_PATH to get environment variables from .env files
  //TODO move all env related stuff to .env files
  env: "dev",
  //    env : 'live',

  /** Dev Settings */

  api_env: process.env.VUE_APP_API_PATH,
  return_domain: "http://localhost:8080",
  esp_domain: "dev-esp.spectrumwellness.ie",
  stripe_key: process.env.VUE_APP_STRIPE_KEY,
  zen_desk_key: "0c6ea862-cbb8-419a-9bfa-4a3903d971c5",
  // Standalone live-webchat app, embedded via iframe (CR-415). All Twilio config lives
  // there; region selects which Flex account it boots.
  webchat_url: process.env.VUE_APP_WEBCHAT_URL,
  webchat_region: webchatRegion(process.env.VUE_APP_REGION),
  // set by default to qa for jenkins auto deployment, change it when clone to local


  //TODO so this
  /** QA Settings */
  //    api_env : 'https://qa.healthcoach-api.com',
  //    esp_domain : 'esp.surge-qa.com',

  //TODO and this
  /** Live Settings */
  //api_env : 'https://api.aluna.app',
  //esp_domain : 'admin.spectrum.life',
  //    zen_desk_key : '3okxX0ixGGb6EMgCdyN36VEHZseWQFwl',
  //    stripe_key : 'pk_live_BI5krTXE17asvo1ZEeEBEnjF',

  /** Other*/
  options: {
    headers: {
      "Content-type": 'application/json'
    }
  },
  encrypt_level: "high",
  adminEmail: "admin@example.com"
};
